<template>

  <component :is="page" />

</template>


<script lang="js">
import { mapGetters } from 'vuex';
import PageWitisi from './witisi/business.vue';
import PageMySport from './mysport/business.vue';

export default {
  name: 'BusinessContainer',
  
  components: {
    PageWitisi,
    PageMySport,
  },

  data() {
    return {
      pages: {
        witisi: 'PageWitisi',
        mysport: 'PageMySport',
      },
    };
  },
  
  computed: {
    ...mapGetters('SettingsState', ['pageTypes']),

    page() {
      const pageType = this.pageTypes ? this.pageTypes.business : 'witisi';
      return pageType ? this.pages[pageType] || this.pages.witisi : this.pages.witisi;
    },
  },
}
</script>
